import { ECOM_PLATFORM_APP_DEF_ID } from './consts';
export class ViewerContext {
  constructor(controllerConfig, siteStore) {
    this.controllerConfig = controllerConfig;
    this.siteStore = siteStore;
  } //
  isExperimentEnabled(key) {
    if (this.siteStore) {
      return this.siteStore.experiments.enabled(key);
    }
    return this.controllerConfig.essentials.experiments.enabled(key);
  }
  isSSR() {
    if (this.siteStore) {
      return this.siteStore.isSSR();
    }
    return this.controllerConfig.wixCodeApi.window.rendering.env === 'backend';
  }
  getDeviceType() {
    if (this.siteStore) {
      return this.siteStore.formFactor;
    }
    return this.controllerConfig.wixCodeApi.window.formFactor;
  }
  getViewMode() {
    if (this.siteStore) {
      return this.siteStore.viewMode;
    }
    return this.controllerConfig.wixCodeApi.window.viewMode;
  }
  getVisitorId() {
    var _this$controllerConfi;
    if (this.siteStore) {
      return this.siteStore.uuid;
    }
    return (_this$controllerConfi = this.controllerConfig.platformAPIs.bi) == null ? void 0 : _this$controllerConfi.visitorId;
  }
  isPrimaryLanguage() {
    if (this.siteStore) {
      const multiLangFields = this.siteStore.getMultiLangFields();
      return Boolean(!multiLangFields || multiLangFields.isPrimaryLanguage);
    }
    const currentLang = this.controllerConfig.wixCodeApi.window.multilingual.siteLanguages.find(lang => lang.languageCode === this.controllerConfig.wixCodeApi.window.multilingual.currentLanguage);
    return !currentLang || currentLang.isPrimaryLanguage;
  }
  getCurrentLanguage() {
    if (this.siteStore) {
      var _this$siteStore$getMu;
      return ((_this$siteStore$getMu = this.siteStore.getMultiLangFields()) == null ? void 0 : _this$siteStore$getMu.lang) || 'en';
    }
    if (this.controllerConfig.wixCodeApi.window.multilingual.isEnabled) {
      return this.controllerConfig.wixCodeApi.window.multilingual.currentLanguage.split('-')[0];
    }
    return this.controllerConfig.wixCodeApi.site.language || 'en';
  }
  getEcomPlatformInstanceId() {
    if (this.siteStore) {
      return this.siteStore.storeId;
    }
    return this.controllerConfig.appParams.instanceId;
  }
  getEcomPlatformPublicAPI() {
    return this.controllerConfig.wixCodeApi.site.getPublicAPI(ECOM_PLATFORM_APP_DEF_ID);
  }
  async getSectionUrl(sectionId) {
    const section = await this.getSectionUrlConfig(sectionId);
    return section == null ? void 0 : section.url;
  }
  async navigateToSection(sectionId, queryParams) {
    if (this.siteStore) {
      return this.siteStore.navigate({
        sectionId,
        queryParams
      }, true);
    }
    const sectionUrlConfig = await this.getSectionUrlConfig(sectionId);
    if (!(sectionUrlConfig != null && sectionUrlConfig.relativeUrl) || !this.controllerConfig.wixCodeApi.location.to) {
      throw new Error(`Can't navigate to ${sectionId}`);
    }
    const url = new URL(sectionUrlConfig.relativeUrl, 'https://dummy');
    Object.entries(queryParams || {}).forEach(_ref => {
      let [key, value] = _ref;
      return url.searchParams.append(key, value);
    });
    return this.controllerConfig.wixCodeApi.location.to(url.pathname + url.search);
  }
  getSectionUrlConfig(sectionId) {
    const params = {
      sectionId,
      appDefinitionId: ECOM_PLATFORM_APP_DEF_ID
    };
    return this.controllerConfig.wixCodeApi.site.getSectionUrl(params, false);
  }
}
//# sourceMappingURL=ViewerContext.js.map